// Registry of role pages on the v2 design (wave 1). A slug listed here renders RoleLandingPageV2;
// every other slug keeps the original template untouched. GENERATED by gen_v2.py.
import ai_social_media_manager from './ai-social-media-manager';
import ai_executive_assistant from './ai-executive-assistant';
import ai_recruiter from './ai-recruiter';
import ai_data_analyst from './ai-data-analyst';
import ai_receptionist from './ai-receptionist';
import ai_virtual_assistant from './ai-virtual-assistant';
import ai_sdr from './ai-sdr';
import ai_content_creator from './ai-content-creator';
import ai_project_manager from './ai-project-manager';
import ai_bookkeeper from './ai-bookkeeper';

export const ROLE_V2 = {
  'ai-social-media-manager': ai_social_media_manager,
  'ai-executive-assistant': ai_executive_assistant,
  'ai-recruiter': ai_recruiter,
  'ai-data-analyst': ai_data_analyst,
  'ai-receptionist': ai_receptionist,
  'ai-virtual-assistant': ai_virtual_assistant,
  'ai-sdr': ai_sdr,
  'ai-content-creator': ai_content_creator,
  'ai-project-manager': ai_project_manager,
  'ai-bookkeeper': ai_bookkeeper,
};
